import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function Pricing() {
  return <section id="pricing" className="py-24 px-4 bg-forest text-offwhite relative overflow-hidden" data-id="element-227">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-gradient-to-b from-forest-light/20 to-transparent pointer-events-none" data-id="element-228" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-229">
        <FadeIn data-id="element-230">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold mb-6" data-id="element-231">
            Deja de vivir con el tanque en reserva.
          </h2>
          <p className="text-xl sm:text-2xl text-sage-dark mb-12" data-id="element-232">
            Recupera tu derecho biológico a tener energía constante.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-233">
          <div className="bg-white text-charcoal p-8 sm:p-12 rounded-3xl shadow-2xl max-w-xl mx-auto transform hover:scale-[1.02] transition-transform duration-300" data-id="element-234">
            <div className="uppercase tracking-widest text-sm font-bold text-forest/60 mb-4" data-id="element-235">
              Precio de Lanzamiento
            </div>
            <div className="flex items-center justify-center gap-2 mb-1" data-id="element-236">
              <span className="text-xl font-medium text-charcoal/40 line-through" data-id="element-237">
                $19 USD
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-238">
              <span className="text-2xl font-medium text-forest/60" data-id="element-239">$</span>
              <span className="text-6xl font-bold text-forest" data-id="element-240">6.70</span>
              <span className="text-xl font-medium text-forest/60" data-id="element-241">USD</span>
            </div>
            <div className="text-sm text-forest/60 mb-6 flex items-center justify-center gap-1" data-id="element-242">
              <Lock size={14} data-id="element-243" /> Acceso Inmediato
            </div>

            <div className="bg-amber/10 border border-amber/30 rounded-xl p-4 mb-8 text-left" data-id="element-244">
              <div className="flex items-center gap-2 mb-1" data-id="element-245">
                <span className="bg-amber text-forest text-xs font-bold px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-246">
                  Gratis
                </span>
                <span className="font-bold text-forest text-sm" data-id="element-247">
                  Bono Incluido
                </span>
              </div>
              <p className="font-serif font-bold text-forest text-base mb-1" data-id="element-248">
                🧭 La Brújula del Comprador
              </p>
              <p className="text-charcoal/60 text-xs mb-1" data-id="element-249">
                Cómo leer etiquetas de suplementos en 60 segundos sin ser
                experto.
              </p>
              <p className="text-amber-hover font-semibold text-sm" data-id="element-250">
                Valor:{' '}
                <span className="line-through text-charcoal/40" data-id="element-251">$10 USD</span> —{' '}
                <span className="text-forest" data-id="element-252">GRATIS</span>
              </p>
            </div>

            <Button href="https://guias-salud.com/cart/46220191006908:1" className="w-full mb-6" onBeforeNavigate={trackAddToCart} data-id="element-253">
              ¡QUIERO EMPEZAR MI RESET DE ENERGÍA AHORA!
            </Button>

            <p className="text-sm text-charcoal/60" data-id="element-254">
              Descarga inmediata. Comienza a cerrar tus brechas nutricionales
              hoy mismo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}